// Regex is the same as Zod's email() validation
export const isEmailValid = (email: string) => {
  return !!email.match(
    /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i
  );
};
